// Must be first: patches ResizeObserver + silences the benign RO loop warning
// before React/Recharts capture the native constructor.
import './lib/resizeObserverFix';
import React from 'react';
import ReactDOM from 'react-dom/client';
import GoogleAuthShell from './components/common/GoogleAuthShell';
import './index.css';
import './styles/dark-mode.css';
import './styles/theme-transition.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './lib/cloudSync';
import { initNativeSafeArea } from './lib/nativeSafeArea';
import { initNativeKeyboard } from './lib/nativeKeyboard';
import { initNativeOtaRefresh } from './lib/nativeOtaRefresh';
import { preinitNativeGoogleSignIn } from './lib/googleAuth';
import { applyFontPreferences, readFontPreference } from './lib/fontSettings';
import { applyThemePreferences, readColorTheme } from './lib/themeSettings';
import { applyDarkMode, readDarkMode } from './lib/darkMode';
import { readAppLanguage } from './lib/i18n/languageStore';
import { dismissBootSplash, markBootSplashStarted } from './lib/bootSplash';

import './components/Landing_Page/LandingPage.css';

markBootSplashStarted();
void initNativeSafeArea();
void initNativeKeyboard();
initNativeOtaRefresh();
void preinitNativeGoogleSignIn();
applyThemePreferences(readColorTheme());
applyDarkMode(readDarkMode(), false);
applyFontPreferences(readFontPreference(), readAppLanguage());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleAuthShell>
      <App />
    </GoogleAuthShell>
  </React.StrictMode>
);

// Hold splash through first paint, then exit.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    void dismissBootSplash();
  });
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
